import {SEGMENT_ACTION, SEGMENT_RESET} from '../../constants';
import {ISegmentResetAction} from './types';

export const segmentResetAction = (): ISegmentResetAction => ({
    type: SEGMENT_ACTION,
    case: SEGMENT_RESET
});
